import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILeadStatusConfiguration } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type ILeadStatusConfigurationState } from './types';

export const mutations: MutationTree<ILeadStatusConfigurationState> = {
    [RECEIVE_DATA_OBJECTS](_state: ILeadStatusConfigurationState, { dataObjectList }: { dataObjectList: ILeadStatusConfiguration[] }) {
        for (const dataObject of dataObjectList) {
            const mergedObj = Object.assign({}, _state.dataObjectList.get(dataObject.dobjId), dataObject);
            _state.dataObjectList.set(dataObject.dobjId, mergedObj);

            if (dataObject.status !== undefined) {
                _state.byStatus.set(dataObject.status.toString(), dataObject.dobjId);
            }
        }
    },

    [REMOVE_DATA_OBJECTS](_state: ILeadStatusConfigurationState, { dobjId }: { dobjId: number }) {
        if (_state.dataObjectList.has(dobjId) && _state.dataObjectList.get(dobjId).status !== undefined) {
            _state.byStatus.delete(_state.dataObjectList.get(dobjId).status.toString());
            _state.dataObjectList.delete(dobjId);
        }
    }
};
